const subscriptions = {
	namespaced: true,
	state: {
      subscriptions: [],
      gifts:[{
         email: 'nik@webthread.com.au',
         channels: 5,
         users: 2
      },{
         email: 'david@davidho.sg',
         channels: 5,
         users: 2
      }],
		paypalSubscriptions: []
	},
	getters: {
		getSubscriptions(state){
			return state.subscriptions
		},
		getGifts(state){
			return state.gifts
		},
		getPaypalSubscriptions(state){
			return state.paypalSubscriptions
		}
	},
	mutations: {
		setSubscriptions(state, subscriptions){
			state.subscriptions = subscriptions;
		},
		setExternalSubscriptions(state, subscriptions){
			state.paypalSubscriptions = subscriptions;
		}
	},
	actions: {
		setSubscriptions({ commit }, subscriptions){
			commit('setSubscriptions', subscriptions)
		},
		setExternalSubscriptions({ commit }, subscriptions){
			commit('setExternalSubscriptions', subscriptions)
		}
	}
}

export default subscriptions;


// WEBPACK FOOTER //
// ./src/store/subscriptions.js